import config from '../config';
import {get} from '../http';

async function getTutorials({route}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  let query = new URLSearchParams();
  if (route) query.append("route", route);


  return await get(
    `${config.baseUrl}/tutorial?app=haya&${query.toString()}`,
    headers
  );
}

const tutorialService = {
  getTutorials,
};

export default tutorialService;
